import { Box, Container, Stack, Typography } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { FancyLightButton } from './FancyLightButton'
import { SECTION_DARK, CHECKCIRCLE_SIZE } from '../theme'

interface SelfQualificationSectionProps {
    title?: string
    subtitle?: string
    note?: string
    items: string[]
    color: string
    onDemoClick: () => void
}

export function SelfQualificationSection({
    title = 'Is this the right solution for you?',
    subtitle = "This solution is designed for a specific type of business. If the statements below resonate, you're in the right place",
    note = "Not sure if this is the right fit? Book a no-obligation call and we'll tell you honestly",
    items,
    color,
    onDemoClick,
}: SelfQualificationSectionProps) {
    return (
        <Box sx={{ ...SECTION_DARK }}>
            <Container maxWidth="md">
                <Typography variant="h3" sx={{ color: 'white', textAlign: 'center', mb: 2 }}>
                    {title}
                </Typography>
                <Typography sx={{ color: 'rgba(255,255,255,0.5)', textAlign: 'center', mb: 6 }}>
                    {subtitle}
                </Typography>
                <Stack spacing={1.5}>
                    {items.map(q => (
                        <Box key={q} sx={{
                            display: 'flex', gap: 2, alignItems: 'flex-start',
                            background: 'rgba(255,255,255,0.04)',
                            border: `1px solid ${color}25`,
                            borderRadius: 2, p: 2.5,
                        }}>
                            <CheckCircleIcon sx={{ color: color, fontSize: CHECKCIRCLE_SIZE, mt: 0.2, flexShrink: 0 }} />
                            <Typography sx={{ color: 'rgba(255,255,255,0.75)', fontSize: '15px', lineHeight: 1.6 }}>{q}</Typography>
                        </Box>
                    ))}
                </Stack>
                <Box sx={{ textAlign: 'center', mt: 5 }}>
                    <Typography sx={{ color: 'rgba(255,255,255,0.35)', fontSize: '14px', mb: 3 }}>
                        {note}
                    </Typography>
                    <FancyLightButton onClick={onDemoClick} color={color}>
                        Book a Discovery Call
                    </FancyLightButton>
                </Box>
            </Container>
        </Box>
    )
}
